export default __webpack_public_path__ + "static/media/norwich-main.53151353.jpg";